import React, { useState, useEffect } from "react"

import './style.scss'
const navs = [
  { name: 'Overview', id: 'page-overview' },
  { name: 'Paper Submissions', id: 'page-paper' },
  // {name:'Competition',id: 'page-important' },
  { name: 'Call for<br/>Papers', id: 'page-call' },
  { name: 'Best<br/>Paper Awards', id: 'page-best-paper-awards' },
  { name: 'Competition', id: 'page-competition' },
  { name: 'Invited<br/>Speakers', id: 'page-invited' },
  { name: 'Schedule', id: 'page-schedule' },
  { name: 'Organizers', id: 'page-organizers' },
  { name: 'Accepted Papers', id: 'page-accepted-papers' },
  // { name: 'Program<br/>Committee', id: 'page-program' },
  { name: 'Previous<br/>Workshops', id: 'page-previous' },
  { name: 'Sponsors', id: 'page-sponsors' },
  // { name: 'Submission<br/>site', id: 'page-submission' },
  { name: 'Contact', id: 'page-contact' },
]
export default function Header() {
  let isScoll = true;
  const [act, setAct] = useState(0);
  const [dian, setDian] = useState(false);

  // 防抖方法
  const debounce = (fn, wait = 200) => {
    var timeout = null;
    return function () {
      if (timeout !== null) clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    }
  }
  const scrollFun = () => {
    const y = window.scrollY; // 滚动条位置
    for (let i = 0; i < navs.length; i += 1) { // 遍历要跳转的锚点
      const Html = document.getElementsByClassName(navs[i].id)[0]; // 获取锚点位置
      if (Html && y >= (Html.offsetTop - 80) && isScoll) {
        setAct(i);
      }
    }
  }


  useEffect(() => {
    window.onscroll = debounce(scrollFun)
  }, [])
  return <div>
    <div className="page-header">
      <div className="logo-box">
        <img className="logo" alt="" src="https://img.alicdn.com/imgextra/i1/O1CN01fmlSsr1MEcOEMvBEQ_!!6000000001403-2-tps-161-41.png" />
      </div>
      <div className="nav-box">
        <div className="nav-ul">
          {navs.map((item, index) => {
            return <div className={index === act ? 'act' : ''} key={index} onClick={() => {
              isScoll = false;
              const Html = document.getElementsByClassName(item.id)[0]; // 获取锚点位置
              window.scrollTo(0, Html.offsetTop - 80);
              setAct(index);
              setTimeout(() => {
                isScoll = true;
              }, 300);
            }}>
              {item.name.split('<br/>')[0]}<br />
              {item.name.split('<br/>')[1] && item.name.split('<br/>')[1]}
            </div>
          })}
        </div>
      </div>
    </div>
    <div className="page-header-mobile">
      <div className="logo-box">
        <img className="logo" src="https://img.alicdn.com/imgextra/i1/O1CN01fmlSsr1MEcOEMvBEQ_!!6000000001403-2-tps-161-41.png" />
        <div className="diandian" onClick={() => { setDian(!dian) }}>
          <img alt="" src="https://img.alicdn.com/imgextra/i4/O1CN0119KkEt20lfY3WJ3aJ_!!6000000006890-2-tps-48-48.png" />
        </div>
      </div>
      {dian && <div className="nav-box">
        <div className="nav-ul">
          {navs.map((item, index) => {
            return <div className={index === act ? 'act' : ''} key={index} onClick={() => {
              const Html = document.getElementsByClassName(item.id)[0]; // 获取锚点位置
              window.scrollTo(0, Html.offsetTop - 65);
              setAct(index);
              setDian(false)
            }}>
              {item.name.split('<br/>')[0]} &nbsp;
              {item.name.split('<br/>')[1] && item.name.split('<br/>')[1]}
            </div>
          })}

        </div>
      </div>}
    </div>
  </div>
}
